module.exports = __webpack_public_path__ + "img/qilin-stage3-blink.36e3bd9d.png";